import logger from '../logger'
import extendedObservable from './base'
import api from '../api'
import {
  forEach,
  uniq,
  get,
  reduce,
  isArray,
  isEqual,
} from 'lodash-es'
import './line-items'


export function StoresObservable() {
  extendedObservable(this, 'storesModel', [])

  let hasFetchedData = false
  let localOrderPickupItems = []

  // successHandler for successful communication with the retail store service
  const apiSuccessHandler = json => new Promise((resolve) => {
    logger('SUCCESS :: Communicated with Retail Store Service', 'info')()
    logger(json, 'debug')()
    resolve(json)
  })

  // errorHandler for unsuccessful communication with the retail store service
  const errorHandler = xhr => new Promise((resolve, reject) => {
    const errorThrown = xhr.statusText
    const status = xhr.status
    logger(`ERROR :: (XHR) Failed to communicate with Retail Store Service ${errorThrown}`, 'error')()
    logger(`Status: ${status}`, 'error')()
    logger(xhr, 'error')()
    reject('errorHandler reject')
  })

  const getOneStoreInfo = storeNumber => new Promise((resolve, reject) => {
    api.stores.get(storeNumber)
      .then(apiSuccessHandler)
      .then(resolve)
      .fail(errorHandler)
      .fail(reject)
  })

  const getStoresInfo = pickupLocations => new Promise((resolve) => {
    let storeInfoArray = []
    let storePromiseArray = [] // eslint-disable-line prefer-const
    forEach(pickupLocations, (storeNumber) => {
      storePromiseArray.push(
        getOneStoreInfo(storeNumber)
          .then((storeInfoObj) => {
            storeInfoArray.push(storeInfoObj)
          })
          .catch(() => {
            storeInfoArray.push('noStoreData')
          })
      )
    })
    Promise.all(storePromiseArray)
      .then(() => {
        storeInfoArray = uniq(storeInfoArray)
        resolve(storeInfoArray)
      })
  })

  const filterStores = pickupLineItems => new Promise((resolve, reject) => {
    logger('filtered pickup locations', 'debug')()
    let pickupLocations = []
    if (pickupLineItems) {
      forEach(pickupLineItems, (a) => {
        pickupLocations.push(a.shippingAddress.address.storeId)
      })
      pickupLocations = uniq(pickupLocations)
      if (pickupLocations) {
        resolve(pickupLocations)
      } else {
        reject()
      }
    }
  })

  const successHandler = storeInfoArray => new Promise((resolve) => {
    this.model = storeInfoArray
    resolve()
  })

  // register and unregister event listeners
  this.on('registerStoresObserver', observer => this.registerObserver(observer))
  this.on('unregisterStoresObserver', observer => this.unregisterObserver(observer))

  this.on('update', (data) => {
    const pickupLineItems = get(data, 'orderModel.getters.filteredPickupLineItems')

    // If there are no line items, fail fast
    if (!pickupLineItems.length) return

    const reducedPickupItems = reduce(pickupLineItems, (res, value) => {
      res.push({ reiRefId: value.reiRefId, sku: value.sku, quantity: value.quantity })
      return res
    }, [])

    // If there are lineItems and the data is not equal to the local
    if (isArray(pickupLineItems) && !isEqual(localOrderPickupItems, reducedPickupItems)) {
      // We need to have a clean way to compare items on the order. Because
      // the line items are somewhat mutable, we compare on the data most
      // important to deciding if a call to fulfillments is necessary:
      // sku, quantity and reiRefId
      localOrderPickupItems = reduce(pickupLineItems, (res, value) => {
        res.push({ reiRefId: value.reiRefId, sku: value.sku, quantity: value.quantity })
        return res
      }, [])
      hasFetchedData = false
    }

    if (!hasFetchedData && pickupLineItems.length > 0) {
      filterStores(pickupLineItems)
        .then(getStoresInfo)
        .then(successHandler)
        .then(this.notifyObservers)
        .then(() => {
          hasFetchedData = true
        })
        .catch((err) => {
          logger(err, 'debug')()
          hasFetchedData = false
        })
    }
  })
}
